import { render, staticRenderFns } from "./ProjectEvents.vue?vue&type=template&id=71c566d6&scoped=true&lang=html&"
import script from "./ProjectEvents.vue?vue&type=script&lang=js&"
export * from "./ProjectEvents.vue?vue&type=script&lang=js&"
import style0 from "./ProjectEvents.vue?vue&type=style&index=0&id=71c566d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c566d6",
  null
  
)

export default component.exports